export const trivia = require('./trivia.png');
export const wallet = require('./wallet.png');
export const store = require('./store.jpg');
export const blogs = require('./blogs.jpg')
export const starwars = require('./starwars.png')
export const tfc = require('./tfc.png')
export const integrado = require('./integrado.jpg')
export const proagro = require('./proagro.jpg')
export const carShop = require('./carShop.jpg')
